import { useMutation } from "@tanstack/react-query";
import { saveProject } from "../api";
import type { ProjectFormValues } from "../../types";

// Mutation hook for saving a project
export const useSaveProjectMutation = () => {
  return useMutation({
    mutationFn: async (data: ProjectFormValues) => {
      const response = await saveProject(data);
      return response.data;
    },
  });
};
